import { useEffect, useState } from "react";
import { client } from "@/api/client.gen";
import { appState } from "@/app/appState";

export type PaletteSkill = { key: string; command: string; source?: "system" | "user" };

/**
 * The skills offered in the `/` palette. Refetched when the locale changes (system
 * commands are i18n strings) and when the user's own skills change. Call from an
 * observer component so the user-skill change is seen.
 */
export const usePaletteSkills = (): PaletteSkill[] => {
    const [skills, setSkills] = useState<PaletteSkill[]>([]);
    const userSkillsVersion = appState.userSkills.map((s) => `${s.id}:${s.last_updated_at}`).join(",");

    useEffect(() => {
        let cancelled = false;
        client.post({
            url: "/api/chat/list-skills",
            body: {},
            headers: { "Content-Type": "application/json" },
        }).then((response) => {
            if (cancelled) return;
            const data = response.data as { skills?: PaletteSkill[] } | undefined;
            if (data?.skills) setSkills(data.skills);
        }).catch(() => undefined);
        return () => { cancelled = true; };
    }, [appState.locale, userSkillsVersion]);

    return skills;
};
